import styled from 'styled-components';
import { WorkflowWrapper as WorkflowWrapperBase } from '../../Workflow/Workflow.styles';

export const AccountsWrapper = styled.div.attrs({ id: 'doNotAcceptOldStyles' })({
  height: '100%',
});

export const WorkflowWrapper = styled(WorkflowWrapperBase)({
  maxWidth: 1200,
});
